"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(1),
      '&:hover': {
        backgroundColor: 'transparent',
        '& $icon': {
          border: "2px solid ".concat(theme.palette.NEUTRAL300)
        },
        '& $checkedIcon': {
          border: "2px solid ".concat(theme.palette.BLUE400),
          '&:before': {
            backgroundColor: theme.palette.BLUE400
          }
        }
      },
      '&.Mui-disabled': {
        '& $icon': {
          border: "2px solid ".concat(theme.palette.NEUTRAL050)
        },
        '& $checkedIcon': {
          border: "2px solid ".concat(theme.palette.BLUE075),
          '&:before': {
            backgroundColor: theme.palette.BLUE075
          }
        }
      }
    },
    icon: {
      borderRadius: '50%',
      width: 16,
      height: 16,
      border: "2px solid ".concat(theme.palette.NEUTRAL100),
      backgroundColor: theme.palette.NEUTRAL000,
      '$root.Mui-focusVisible &': {
        outline: "2px auto ".concat(theme.palette.BLUE400),
        outlineOffset: 3
      }
    },
    checkedIcon: {
      border: "2px solid ".concat(theme.palette.BLUE400),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&:hover': {
        border: "2px solid ".concat(theme.palette.RED500),
        '&:before': {
          backgroundColor: theme.palette.RED500
        }
      },
      '&:before': {
        display: 'block',
        width: 10,
        height: 10,
        backgroundColor: theme.palette.BLUE400,
        content: '""',
        borderRadius: '50%'
      }
    },
    label: {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL800,
      marginLeft: theme.spacing(0),
      '&.Mui-disabled': {
        color: theme.palette.NEUTRAL100
      }
    }
  };
});
var _default = useStyles;
exports.default = _default;